'use strict'

import React from 'react'

export default class Footer extends React.Component {
  render () {
    return (
      <div className='footer'>
        <div className='container'>
          <address className='visible-xs'>
            <b>Dental Members Australia</b>
            <br />
            <br />
            Email <a href='mailto:info@dentalmembers.com.au '>info@dentalmembers.com.au</a>
          </address>
          <ul className='list-unstyled nav-footer visible-xs'>
            <li>
              <a href='/'>Home</a>
            </li>
            <li>
              <a href='/treatment-vouchers'>Dental Vouchers</a>
            </li>
            <li>
              <a href='/care-plan'>Care Plan</a>
            </li>
            <li>
              <a href='/treatment-plan'>Treatment Plan</a>
            </li>
            <li>
              <a href='/about-dma'>About DMA</a>
            </li>
            <li className='child'>
              <a href='/about-dma/what-our-patients-say'>What our Patients say</a>
            </li>
            <li className='child'>
              <a href='/about-dma/faq'>FAQs Care Plan</a>
            </li>
            <li className='child'>
              <a href='/about-dma/news'>In the Media</a>
            </li>
            <li className='child'>
              <a href='/about-dma/find-a-dentist'>Find a Dentist</a>
            </li>
            <li className='child'>
              <a href='/about-dma/blog'>Blog</a>
            </li>
            <li className='child'>
              <a href='/about-dma/affordable-dental-care-for-families'>Care Plan for Families</a>
            </li>
            <li className='child'>
              <a href='/about-dma/dental-packages-faqs'>FAQs Dental Vouchers</a>
            </li>
            <li>
              <a href='/contact'>Contact Us</a>
            </li>
            <li>
              <a href='/dentist'>For Dentists</a>
            </li>
          </ul>
          <div className='row'>
            <div className='col-lg-9 col-sm-8'>
              <div className='row hidden-xs'>
                <div className='col-sm-3'>
                  <ul className='list-unstyled'>
                    <li>
                      <a href='/'>Home</a>
                    </li>
                    <li>
                      <a href='/treatment-vouchers'>Dental Vouchers</a>
                    </li>
                  </ul>
                </div>
                <div className='col-sm-3'>
                  <ul className='list-unstyled'>
                    <li>
                      <a href='/dentist'>For Dentists</a>
                    </li>
                  </ul>
                </div>
                <div className='col-sm-3'>
                  <ul className='list-unstyled'>
                  </ul>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-sm-4'>
              <address className='hidden-xs'>
                <b>Dental Members Australia</b>
                <br />
              </address>
              <br />
              <address className='hidden-xs'>
                Email <a href='mailto:info@dentalmembers.com.au '>info@dentalmembers.com.au</a>
              </address>
              <br />
              <div className='copy'>
                © Copyright 2010-2017 Dental Members Australia.
                <br />
                All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/footer.js